import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setBackLayout, setToast } from "../../redux/slice/system";
import { setUser } from "../../redux/slice/user";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import moment from "moment";

import BackSidebar from "./sidebar";
import BackTopbar from "./topbar";

import LayoutCss from "../../styles/components/layout.module.scss";

import { classNames } from "primereact/utils";

export default function BackLayoutMain(props) {
  const { model = "back" } = props;
  const system = useSelector((state) => state.system);
  const dispatch = useDispatch();
  const redux_user = useSelector((state) => state.user);
  const route_location = useLocation();
  const navigate = useNavigate();
  // 螢幕大小設定
  const [screen, setScreen] = useState({
    width: null,
    height: null,
  });

  // 偵測是否有登入資料，沒有則導回登入頁
  useEffect(() => {
    let user_local = localStorage.getItem("user");
    if (!redux_user.userDetail && !user_local) {
      let { pathname } = route_location;
      localStorage.setItem("prePage", pathname);
      navigate("/login");
    } else {
      localStorage.removeItem("prePage");
    }
  }, []);

  // 偵測螢幕大小
  useEffect(() => {
    const resize = () => {
      setScreen({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", resize);

    resize();

    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  // 依照螢幕大小控制 sidebar
  useEffect(() => {
    if (!screen.width || !screen.height) {
      return;
    }

    if (screen.width <= 768) {
      dispatch(
        setBackLayout({
          isSideShow: false,
          isSideFixed: false,
        })
      );
    } else {
      dispatch(
        setBackLayout({
          isSideFixed: true,
        })
      );
    }
  }, [screen]);

  useEffect(() => {
    let timer = setInterval(() => {
      if (redux_user.userDetail) {
        let diff = moment().diff(redux_user.userDetail?.now);

        if (diff >= 3 * 60 * 60 * 1000 || !redux_user.userDetail?.now) {
          dispatch(
            setToast({
              severity: "error",
              summary: "超過使用時限，請重新登入",
              detail: "",
            })
          );
          dispatch(setUser(null));
          window.location.href = "/login";
        }
      } else {
        clearInterval(timer);
      }
    }, 5000);

    return () => {
      clearInterval(timer);
    };
  }, [redux_user.userDetail]);

  return (
    <>
      <div
        className={`${LayoutCss["back-layout-wrap"]} ${
          system.backLayout.isSideFixed &&
          `${LayoutCss["layout-sidebar-fixed"]}`
        } ${
          system.backLayout.isSideShow && `${LayoutCss["layout-sidebar-show"]}`
        }`}
      >
        {/* 左側區塊 */}
        {model !== "self" && (
          <BackSidebar model={model} LayoutCss={LayoutCss} />
        )}

        <div className={`${LayoutCss["layout-body"]}`}>
          {/* 上方區塊 */}
          <BackTopbar model={model} LayoutCss={LayoutCss} />

          <div
            id="layout-body-content"
            className={classNames(
              "relative",
              LayoutCss["layout-body-content"],
              {
                [LayoutCss["layout-body-content-teach"]]: model === "teach",
              }
            )}
          >
            {/* 內容區塊，依照 route 顯示不同元件 */}
            {redux_user.userDetail && <Outlet />}
          </div>
        </div>
      </div>
    </>
  );
}
